"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleTheme = exports.getSlideHoverStyles = exports.getHandleColor = exports.getFocusRingStyles = exports.getBorder = exports.getBackgroundColor = void 0;
var _core = require("@emotion/core");
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _colors = require("../../../constants/colors");
var _grid = require("../../../constants/grid");
var _spacing = require("../../../constants/spacing");
var _createFocusRingStyles = require("../../../util/createFocusRingStyles");
const toggleTheme = (0, _sdsThemeInternal.themed)({
  borderColor: {
    checked: "transparent",
    checkedHover: "transparent",
    checkedPressed: "transparent",
    checkedDisabled: "transparent",
    invalid: {
      "lodestar-light": "transparent",
      "ursa-light": (0, _designTokensReact.color)("color--border--error--default")
    },
    unchecked: {
      "lodestar-light": "transparent",
      "ursa-light": (0, _designTokensReact.color)("color--border--neutral--weak")
    },
    uncheckedHover: {
      "lodestar-light": "transparent",
      "ursa-light": (0, _designTokensReact.color)("color--border--neutral--weak")
    },
    uncheckedPressed: {
      "lodestar-light": "transparent",
      "ursa-light": (0, _designTokensReact.color)("color--border--neutral--weak")
    },
    uncheckedDisabled: {
      "lodestar-light": "transparent",
      "ursa-light": (0, _designTokensReact.color)("color--border--neutral--weak")
    }
  },
  backgroundColor: {
    checked: {
      "lodestar-light": _designTokens.lodestarColors.buttonPrimary,
      // no semantic token
      "ursa-light": (0, _designTokensReact.color)("color--background--primary--default")
    },
    checkedHover: {
      "lodestar-light": _designTokens.lodestarColors.buttonPrimaryHover,
      // no semantic token
      "ursa-light": (0, _designTokensReact.color)("color--background--primary--strong")
    },
    checkedPressed: {
      "lodestar-light": _designTokens.lodestarColors.buttonPrimaryFocus,
      // no semantic token
      "ursa-light": (0, _designTokensReact.color)("color--background--primary--stronger")
    },
    checkedDisabled: {
      "lodestar-light": (0, _colors.toRgba)(_designTokens.lodestarColors.buttonPrimary, 0.4),
      // no semantic token
      "ursa-light": (0, _designTokensReact.color)("color--background--primary--weak")
    },
    invalid: {
      "lodestar-light": (0, _designTokensReact.color)("color--background--error--default"),
      "ursa-light": (0, _designTokensReact.color)("color--background--surfaces--body")
    },
    unchecked: {
      "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--stronger"),
      "ursa-light": (0, _designTokensReact.color)("color--background--surfaces--body")
    },
    uncheckedHover: {
      "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--strong"),
      "ursa-light": (0, _designTokensReact.color)("color--background--neutral--weakest")
    },
    uncheckedPressed: {
      "lodestar-light": _designTokens.lodestarColors.buttonPrimaryHover,
      "ursa-light": (0, _designTokensReact.color)("color--background--neutral--weak")
    },
    uncheckedDisabled: {
      "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--stronger"),
      "ursa-light": (0, _designTokensReact.color)("color--background--surfaces--body")
    }
  },
  focusRingComponentBorderWidth: {
    "lodestar-light": 4,
    "ursa-light": 3
  },
  focusRingComponentRadius: {
    medium: {
      "lodestar-light": 12,
      "ursa-light": 12
    },
    large: {
      "lodestar-light": 18,
      "ursa-light": 12
    }
  },
  handleColor: {
    checked: (0, _designTokensReact.color)("color--background--surfaces--body"),
    invalid: {
      "lodestar-light": (0, _designTokensReact.color)("color--background--surfaces--body"),
      "ursa-light": (0, _designTokensReact.color)("color--background--neutral--strongest")
    },
    unchecked: {
      "lodestar-light": (0, _designTokensReact.color)("color--background--surfaces--body"),
      "ursa-light": (0, _designTokensReact.color)("color--background--neutral--strongest")
    },
    uncheckedDisabled: {
      "lodestar-light": (0, _designTokensReact.color)("color--background--surfaces--body"),
      "ursa-light": (0, _designTokensReact.color)("color--background--neutral--default")
    }
  },
  handleMargin: {
    medium: {
      "lodestar-light": 1,
      "ursa-light": 2
    },
    large: 2
  },
  handleSize: {
    medium: {
      "lodestar-light": _grid.gridSize * 4 - _spacing.sizes.xxSmall - _spacing.sizes.xxSmall / 2,
      "ursa-light": 10
    },
    large: {
      "lodestar-light": _grid.gridSize * 6 - _spacing.sizes.xSmall,
      "ursa-light": 12
    }
  },
  handleTranslateX: {
    medium: {
      offNoHover: "initial",
      offHover: "initial",
      onHover: {
        "lodestar-light": `translateX(14px)`,
        "ursa-light": `translateX(12px)`
      },
      onNoHover: {
        "lodestar-light": `translateX(16px)`,
        "ursa-light": `translateX(12px)`
      }
    },
    large: {
      offNoHover: "initial",
      offHover: {
        "lodestar-light": `translateX(4px)`,
        "ursa-light": `initial`
      },
      onHover: {
        "lodestar-light": `translateX(20px)`,
        "ursa-light": `translateX(14px)`
      },
      onNoHover: {
        "lodestar-light": `translateX(24px)`,
        "ursa-light": `translateX(14px)`
      }
    }
  },
  height: {
    medium: {
      "lodestar-light": `${_grid.gridSize * 4}px`,
      "ursa-light": _designTokens.space.space40
    },
    large: {
      "lodestar-light": `${_grid.gridSize * 6}px`,
      "ursa-light": `calc(${_designTokens.space.space40} + ${_designTokens.space.space10})`
    }
  },
  labelGap: {
    "lodestar-light": "12px",
    "ursa-light": "6px"
  },
  labelMarginTop: {
    medium: "-1px",
    large: {
      "lodestar-light": "3px",
      "ursa-light": "2px"
    }
  },
  motion: {
    animation: {
      "lodestar-light": `0.1s ease-in`,
      "ursa-light": `${_designTokens.motion.animation.default}`
    },
    default: {
      "lodestar-light": `0.2s`,
      "ursa-light": `all ${_designTokens.motion.animation.default}`
    }
  },
  width: {
    medium: {
      "lodestar-light": `${_grid.gridSize * 8}px`,
      "ursa-light": "30px"
    },
    large: {
      "lodestar-light": `${_grid.gridSize * 12}px`,
      "ursa-light": "34px"
    }
  }
});
exports.toggleTheme = toggleTheme;
const getBackgroundColor = _ref => {
  let {
    isActive,
    isChecked,
    isDisabled,
    isInvalid,
    themeMode
  } = _ref;
  let backgroundColor = "";
  if (!isActive) {
    if (isChecked) {
      backgroundColor = toggleTheme.backgroundColor.checked(themeMode);
    } else {
      backgroundColor = toggleTheme.backgroundColor.unchecked(themeMode);
    }
  } else {
    if (isChecked) {
      backgroundColor = toggleTheme.backgroundColor.checkedPressed(themeMode);
    } else {
      backgroundColor = toggleTheme.backgroundColor.uncheckedPressed(themeMode);
    }
  }
  if (isDisabled) {
    if (isChecked) {
      backgroundColor = toggleTheme.backgroundColor.checkedDisabled(themeMode);
    } else {
      backgroundColor = toggleTheme.backgroundColor.uncheckedDisabled(themeMode);
    }
  }
  if (isInvalid) {
    backgroundColor = toggleTheme.backgroundColor.invalid(themeMode);
  }
  return backgroundColor;
};
exports.getBackgroundColor = getBackgroundColor;
const getBorder = _ref2 => {
  let {
    isActive,
    isChecked,
    isDisabled,
    isInvalid,
    themeMode
  } = _ref2;
  let borderColor = "";
  if (!isActive) {
    if (isChecked) {
      borderColor = toggleTheme.borderColor.checked(themeMode);
    } else {
      borderColor = toggleTheme.borderColor.unchecked(themeMode);
    }
  } else {
    if (isChecked) {
      borderColor = toggleTheme.borderColor.checkedPressed(themeMode);
    } else {
      borderColor = toggleTheme.borderColor.uncheckedPressed(themeMode);
    }
  }
  if (isDisabled) {
    if (isChecked) {
      borderColor = toggleTheme.borderColor.checkedDisabled(themeMode);
    } else {
      borderColor = toggleTheme.borderColor.uncheckedDisabled(themeMode);
    }
  }
  if (isInvalid) {
    borderColor = toggleTheme.borderColor.invalid(themeMode);
  }
  return `${_designTokens.border.width20} solid ${borderColor}`;
};
exports.getBorder = getBorder;
const getHandleColor = _ref3 => {
  let {
    isChecked,
    isDisabled,
    isInvalid,
    themeMode
  } = _ref3;
  let handleColor = "";
  if (isChecked) {
    handleColor = toggleTheme.handleColor.checked(themeMode);
  } else {
    if (isDisabled) {
      handleColor = toggleTheme.handleColor.uncheckedDisabled(themeMode);
    } else {
      handleColor = toggleTheme.handleColor.unchecked(themeMode);
    }
  }
  if (isInvalid) {
    handleColor = toggleTheme.handleColor.invalid(themeMode);
  }
  return handleColor;
};
exports.getHandleColor = getHandleColor;
const getSlideHoverStyles = _ref4 => {
  let {
    isActive,
    isChecked,
    isDisabled,
    isInvalid,
    themeMode
  } = _ref4;
  let backgroundColor;
  if (!isDisabled && !isActive) {
    // Disabled and currently active toggles have no hover change.
    backgroundColor = isInvalid ? toggleTheme.backgroundColor.invalid(themeMode) : isChecked ? toggleTheme.backgroundColor.checkedHover(themeMode) : toggleTheme.backgroundColor.uncheckedHover(themeMode);
  }
  return (0, _core.css)`
        &:hover {
            ${backgroundColor ? `background-color: ${backgroundColor};` : ""};
        }
    `;
};
exports.getSlideHoverStyles = getSlideHoverStyles;
const getFocusRingStyles = _ref5 => {
  let {
    size,
    themeMode
  } = _ref5;
  return (0, _createFocusRingStyles.createFocusRingStyles)({
    theme: themeMode,
    gap: 0,
    componentBorderWidth: toggleTheme.focusRingComponentBorderWidth(themeMode),
    componentRadius: toggleTheme.focusRingComponentRadius[size](themeMode),
    ringWidth: 2,
    focusSelector: ":focus-within"
  });
};
exports.getFocusRingStyles = getFocusRingStyles;
//# sourceMappingURL=toggleTheme.js.map